import {
  SALARY_PERCENT,
  SALARY_RATE,
  SALARY_TYPE_SELECT_OPTIONS,
} from './salaryTypeSelectOptions';

export { SALARY_TYPE_SELECT_OPTIONS, SALARY_PERCENT, SALARY_RATE };
